import { styled } from '@mui/material/styles';
import { Typography } from '@raisin/components-lib';

export const Grid = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.spacing(16),
  marginTop: theme.spacing(8),

  [theme.breakpoints.up('md')]: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
  },
}));

export const Content = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    paddingRight: theme.spacing(2),
  },
  [theme.breakpoints.down('md')]: {
    order: 2,
  },
}));

export const Sidebar = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    paddingLeft: theme.spacing(4),
  },
  [theme.breakpoints.down('md')]: {
    order: 1,
  },
}));

export const FeaturedArticlesTitle = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.between('xs', 'sm')]: {
    fontSize: theme.typography.h4.fontSize,
    lineHeight: theme.typography.h4.lineHeight,
  },
}));
